import { produce } from "immer";
import { SET_OPEN_SHIFT_FILTER } from "./constants";

export const initialState = {
  unclaimed: false,
  claimed: false,
};

const OpenShiftFilterReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_OPEN_SHIFT_FILTER:
        Object.assign(draft, action.payload);
        break;
      default:
        break;
    }
  });

export default OpenShiftFilterReducer;
